import React from "react";
import styled from "styled-components";
import CTASection from "../CTASection";
import pennantImage from "../../assets/images/pennant.png";

const SectionContainer = styled.section`
  padding: 50px 20px;
  background-color: #ffffff;
  text-align: center;
`;

const Title = styled.h2`
  font-size: 2.5rem;
  color: #333;
  margin-bottom: 20px;
`;

const Description = styled.p`
  font-size: 1.2rem;
  color: #555;
  max-width: 700px;
  margin: 0 auto 20px;
  line-height: 1.6;
`;

const PennantImage = styled.img`
  width: 100%;
  max-width: 400px;
  margin: 20px auto;
  object-fit: contain;
  background: transparent;
  display: block;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  flex-wrap: wrap;
  margin-top: 20px;
`;

const CTAButton = styled.a`
  display: inline-block;
  background-color: ${(props) => props.bgColor || "#007bff"};
  color: white;
  padding: 15px 30px;
  font-size: 1.2rem;
  border-radius: 5px;
  text-decoration: none;
  transition: background-color 0.3s ease;
  min-width: 220px;
  text-align: center;

  &:hover {
    background-color: ${(props) => props.hoverColor || "#0056b3"};
  }
`;

const CallToActionSection = () => (
  <SectionContainer>
    <Title>
      Help Us Build Our 400th House and Get a Custom Oxford Pennant!
    </Title>
    <Description>
      Donate $100 to support affordable housing and receive a limited-edition,
      commemorative Oxford Pennant celebrating Habitat Buffalo's 40th
      anniversary!
    </Description>

    <PennantImage src={pennantImage} alt="40th Anniversary Oxford Pennant" />

    <ButtonContainer>
      <CTAButton
        href="https://habitatbuffalo.betterworld.org/campaigns/400in40"
        bgColor="#ff9800"
        hoverColor="#e57c00"
      >
        Donate $100 & Get Your Pennant
      </CTAButton>

      <CTAButton
        href="https://habitatbuffalo.betterworld.org/campaigns/400in40"
        bgColor="#007bff"
        hoverColor="#0056b3"
      >
        Sponsor a #400in40 Week
      </CTAButton>
    </ButtonContainer>
  </SectionContainer>
);

export default CallToActionSection;
